import { Button } from "@/components/ui/button";
import moment from "moment";

export function PartUsageSummaryHandler({ currentExport, data, dataSave, exportToExcel }) {
  if (currentExport == "part usage") {
    const exportData =
      data.part_usage_ticket_type == "PRT"
        ? dataSave.part_usages
            .filter((obj) => {
              if (data.date_from && data.date_to) {
                return moment(obj.created_at).isBetween(
                  data.date_from,
                  data.date_to,
                );
              } else {
                return true;
              }
            })
            .filter((obj) => {
              if (data.part_type) {
                return obj.type == data.part_type;
              } else {
                return true;
              }
            })
            .map((obj) => {
              return {
                "Part Number": obj.part_detail.part_number,
                "Part Name": obj.part_detail.name,
                "Inventory Quantity": obj.inventory_quantity,
                "Usage Quantity": obj.usage_quantity,
                "Last Usage Time": obj.created_at
                  ? moment(obj.created_at)
                      .subtract(7, "hours")
                      .format("YYYY-MM-DD HH:mm:ss")
                  : "-",
              };
            })
            .filter((obj) => obj != undefined)
        : dataSave.repair_part_usages
            .filter((obj) => {
              if (data.date_from && data.date_to) {
                return moment(obj.created_at).isBetween(
                  data.date_from,
                  data.date_to,
                );
              }
              return true;
            })
            .map((obj) => {
              return {
                "Part Number": obj.part_detail?.part_number || "-",
                "Part Name": obj.part_detail?.name || "-",
                "Inventory Quantity": obj.inventory_quantity,
                "Usage Quantity": obj.usage_quantity,
                "Last Usage Time": obj.created_at
                  ? moment(obj.created_at)
                      .subtract(7, "hours")
                      .format("YYYY-MM-DD HH:mm:ss")
                  : "-",
              };
            })
            .filter((obj) => obj != undefined);

    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `part_usage_summary_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
